<template>
  <div class="content--sinoreg page--habilitarNascimento HabilitacaoCasamento">
    <header-blue class="headerBlueCadastro">
      <b-row>
        <b-col sm="3"
               class="headerType">
          <icon-svg class="obito-show_icon icon--md typeIcon"
                    icon="engagement" />
          <span class="pt-3 obito-show_title-label">
            E-Habilitação
          </span>
        </b-col>

        <b-col sm="5"
               class="headerInfos">
          <b-row class="resumo-show_title-label pt-2">
            Novo Registro
          </b-row>
          <b-row>
            <HeaderBoxResume :info="dataInicio || new Date() | date"
                             class="cadastroInfos"
                             text="Data de início de preenchimento" />
          </b-row>
        </b-col>
      </b-row>
    </header-blue>

    <StepsForWizard class="my-4"
                    :ativo="wizard.ativo"
                    :passos="wizard.passos"
                    tamanho="md" />

    <div class="mt-5">
      <conjugue v-if="wizard.ativo == 0"
                :prop-pessoa="habilitacao.pessoas[0]"
                :prop-ordem="0"
                :prop-cartorio="dadosCartorio"
                :prop-habilitacao="habilitacao"
                :prop-componente-pai="$options.name"
                @onNomeChanged="searchRascunho"
                @onActive="activeChange"
                @onChange="onChangeConjugue" />

      <conjugue v-if="wizard.ativo == 1"
                :prop-pessoa="habilitacao.pessoas[1]"
                :prop-ordem="1"
                :prop-cartorio="dadosCartorio"
                :prop-habilitacao="habilitacao"
                :prop-componente-pai="$options.name"
                @onActive="activeChange"
                @onChange="onChangeConjugue" />

      <dados-casamento v-if="wizard.ativo == 2"
                       :prop-habilitacao="habilitacao"
                       :prop-registro="habilitacao.registro"
                       :prop-cartorio="dadosCartorio"
                       @onActive="activeChange"
                       @onChange="onChangeDadosCasamento" />

      <impressao-pecas v-if="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? false : wizard.ativo === 3"
                       :prop-habilitacao="habilitacao"
                       @onChangeDeclaracao="onChangeDeclaracao" />

      <preparar-processo v-if="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? wizard.ativo === 3 : wizard.ativo === 4"
                         :prop-documentos="habilitacao.documentos"
                         :prop-tipo-documento="habilitacao.tipo_casamento"
                         @onActive="activeChange"
                         @onEditDoc="editarDocumento"
                         @onDeleteDoc="excluirDocumento"
                         @onNewDocument="novoDocumento" />

      <habilitacao v-show="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? wizard.ativo === 4 : wizard.ativo == 5"
                   :prop-registro="habilitacao.registro"
                   :prop-publicacao="habilitacao.publicacao"
                   :prop-tipo-casamento="habilitacao.tipo_casamento"
                   :prop-tab="wizard.ativo"
                   @onActive="activeChange"
                   @onEmitChange="changeHabilitacao" />
    </div>


    <div class="cadastroHabilitacaoCasamento_footer mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block">
          <b-link v-if="wizard.ativo === 0"
                  class="btn btn-sm btn-dark"
                  :to="{ name: 'rei_dashboard' }">
            Voltar
          </b-link>
          <button v-if="!(wizard.ativo === 0)"
                  class="btn btn-sm btn-dark"
                  type="button"
                  @click="previousActive">
            Voltar
          </button>
        </div>

        <div class="d-inline-block ml-2">
          <button v-show="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? wizard.ativo < 4 : wizard.ativo < 5"
                  v-if="hiddens.btn"
                  class="btn btn-sm btn-primary"
                  type="button"
                  :disabled="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA && wizard.ativo !== 3 ? false : !wizard.passos[wizard.ativo].active"
                  @click="nextWizard">
            Continuar
          </button>

          <button v-show="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? wizard.ativo === 4 : wizard.ativo === 5"
                  v-if="hiddens.btn"
                  class="btn btn-sm btn-primary"
                  type="button"
                  :disabled="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? false : !wizard.passos[wizard.ativo].active"
                  @click="cadastrarHabilitacao">
            Cadastrar Habilitação
          </button>
        </div>
      </div>
    </div>
    <b-modal v-if="rascunhoFound"
             id="modalRascunho"
             ref="modalRascunho"
             no-close-on-backdrop
             no-close-on-esc
             :visible="true"
             centered
             size="xl">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Rascunho encontrado
      </div>
      <SearchRascunho :prop-rascunho="rascunhoFound" />
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button class="btn btn-sm btn-primary"
                @click="() => { cancel(); drafts().check() }">
          Continuar com o Cadastro
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import StepsForWizard from "@/components/SofiaRei/StepsForWizard"
  import Conjugue from "@/components/SofiaRei/HabilitacaoCasamento/Conjugue"
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import DadosCasamento from "@/components/SofiaRei/HabilitacaoCasamento/DadosCasamento"
  import ImpressaoPecas from "@/components/SofiaRei/HabilitacaoCasamento/ImpressaoPecas"
  import PrepararProcesso from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso"
  import Habilitacao from "@/components/SofiaRei/HabilitacaoCasamento/Habilitacao"
  import SearchRascunho from "@/components/SofiaRei/Busca/SearchRascunho.vue"

  /* services */
  import CartorioService from "@/services/CartorioService"
  import HabilitacaoService from "@/services/Registros/Habilitacao"
  import eHabilitacaoService from "@/services/Registros/Habilitacao/eHabilitacaoService"
  import ImpressaoService from "@/services/Registros/ImpressaoService"
  import RegistrosService from "@/services/Registros"
  import UploadTemporarioService from "@/services/Arquivos/UploadTemporarioService"
  import BuscaService from "@/services/BuscaService"

  /* others */
  import moment from "moment"
  import {mapGetters} from "vuex"

  /* constants */
  import { EDITAL_OUTRA_SERVENTIA } from "@/constants/casamento/tipos"


  export default {
    name: "HabilitacaoCasamento",
    components: {
      SearchRascunho,
      HeaderBlue,
      HeaderBoxResume,
      StepsForWizard,
      Conjugue,
      DadosCasamento,
      ImpressaoPecas,
      PrepararProcesso,
      Habilitacao
    },
    props: {
      propHabilitacao: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        EDITAL_OUTRA_SERVENTIA,
        hiddens: {
          btn: true
        },
        wizard: {
          ativo: 0,
          passos: [
            { texto: 'Cônjuge 1', active: false },
            { texto: 'Cônjuge 2', active: false },
            { texto: 'Dados do Casamento', active: false },
            { texto: 'Impressão das Peças', active: true },
            { texto: 'Preparar Processo', active: false },
            { texto: 'Habilitação', active: false }
          ]
        },
        habilitacao: {
          publicacao: 'E_PROCLAMAS',
          data_publicacao: null,
          documentos: [],
          tipo_casamento: null,
          regime_bens: null,
          casamento_em_cartorio: true,
          data_casamento: null,
          hora_casamento: null,
          protocolo_ano: null,
          protocolo_automatico: true,
          pessoas: [
            {
              endereco: null,
              genitores: [],
              registrosAnteriores: [],
              documentos: [],
              nacionalidade_codigo: 76,
            },
            {
              endereco: null,
              genitores: [],
              registrosAnteriores: [],
              documentos: [],
              nacionalidade_codigo: 76,
            }
          ],
          registro: {
            cartorio_id: this.$store.state.auth.cartorio_id,
            tipo_registro: "D", // Habilitação de Casamento - Proclamas
            data_ocorrido: null,
            hora_ocorrido: null,
            data_registro: null,
            partes: [],
            local: {
              descricao: null,
              endereco: {}
            }
          },
          ...this.propHabilitacao
        },
        dataInicio: '',
        dadosCartorio: {},
        id_habilitacao: null,
        rascunhoCriado: false,
        showModalRascunho: false,
        rascunhoFound: null
      }
    },
    watch: {
      'habilitacao.tipo_casamento': function (newVal) {
        if (!newVal) return

        // Retiramos o passo Impressão das Peças de caso for Afixação de edital de outra serventia
        if (newVal === this.EDITAL_OUTRA_SERVENTIA) {
          const passoImpressaoDasPecas = this.wizard.passos.find(passo => passo.texto === 'Impressão das Peças')

          if (passoImpressaoDasPecas) {
            const indexImpressaoDasPecas = this.wizard.passos.indexOf(passoImpressaoDasPecas)

            this.wizard.passos.splice(indexImpressaoDasPecas, 1)
          }


          /**
           * Caso tiver algum documento de memorial, quando o tipo de casamento for Afixação de edital de outra serventia retimos o documento.
           * Pois pra esse tipo de casamento não tem memorial.
           */
          if (this.wizard.ativo === 2) {
            const docMemorial = this.habilitacao.documentos.find(documento => documento.label === 'Memorial')

            if (docMemorial) {
              const indexMemorial = this.habilitacao.documentos.indexOf(docMemorial)

              this.habilitacao.documentos.splice(indexMemorial, 1)
            }
          }
        } else {
          // Validamos se o item 3 não é Impressão das Peças para não duplicar
          if (this.wizard.passos[3].texto !== 'Impressão das Peças') {
            this.wizard.passos.splice(3, 0, { texto: 'Impressão das Peças', active: true })
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    created () {
      this.habilitacao.registro.cartorio_id = this.$store.state.auth.cartorio_id
      this.drafts().exists()
    },
    mounted () {
      this.getCartorio()
    },
    methods: {
      async cadastrarHabilitacao () {
        const menores = []

        this.habilitacao.pessoas.forEach(pessoa => {
          if (pessoa.idade && pessoa.idade < 16) {
            menores.push(pessoa.nome_antigo)
          }
        })

        if (menores.length) {
          const resp = await displayMessage('question', 'Alerta!', `Existem contraentes com idade inferior a 16 anos. Tem certeza que deseja continuar?`)

          if (!resp.value) {
            return
          }
        }

        const tratarHabilitacao = async () => {
          const habilitacao = { ...this.habilitacao }

          /* pegando id do rascunho e atribuindo a habilitacao.regisro */
          const { id } = this.$route.params
          habilitacao.registro.rascunho_id = id

          habilitacao.registro.data_registro = moment().format('YYYY-MM-DD')
        }

        const saveHabilitacao = async (gerarAutuacao = false) => {
          this.habilitacao.gerarAutuacao = gerarAutuacao

          const response = await HabilitacaoService.storeHabilitacao(this.habilitacao)
          return response
        }

        tratarHabilitacao()

        try {
          const gerarAutuacao = status.value || false

          loader({ text: "Salvando Habilitação...", active: true })

          const response = await saveHabilitacao(gerarAutuacao)
          if (response) {
            this.id_habilitacao = response.habilitacao_casamento_id
          }

          if (this.habilitacao.registro.impressao_edital) {
            const id = response.habilitacao_casamento_id
            const post = this.habilitacao

            const edital = await ImpressaoService.getTemplate('habilitacao', { template: 'edital', id, post })
            const declaracoes = await ImpressaoService.getTemplate('habilitacao', { template: 'declaracoes', id, post })

            const html = {
              htmlEdital: edital,
              htmlDeclaracao: declaracoes
            }

            const pdfFile = await HabilitacaoService.getPdfCadastroHabilitacao(html, response)

            let blob = new Blob([pdfFile], { type: 'application/pdf' })
            let url = window.URL.createObjectURL(blob)

            window.open(url)
          }

          this.$router.push({
            name: 'resumo_habilitacao_casamento',
            params: {
              id: response.habilitacao_casamento_id,
              propAutuacao: true
            }
          }).catch(() => {
            this.$router.push('/')
          })
        } catch (e) {
          objSwal.error.title = this.id_habilitacao ? "Erro ao gerar PDF" : "Erro ao salvar."
          objSwal.error.text = ''

          if (e.response.data.message) {
            const { error } = e.response.data.message
            if (error) {
              if (error.message.match('JWT')) {
                objSwal.error.text = 'Login expirado.'
              } else {
                objSwal.error.text = error.message
              }
            } else {
              objSwal.error.text = e.response.data.message
            }
          }

          Swal.fire(objSwal.error).then(() => {
            const msgs = [
              'Configuração do Livro inválida!',
              'Sequência do Livro inválida!',
              'Sequências dos livros',
              'Configurações dos livros'
            ]

            if (this.id_habilitacao) {
              this.$router.push({
                name: 'resumo_habilitacao_casamento',
                params: {
                  id: this.id_habilitacao,
                  propAutuacao: true
                }
              }).catch(() => {
                this.$router.push('/')
              })
            }

            if (e.response.data.message && msgs.includes(e.response.data.message)) {
              this.$router.push({ name: 'cadastro_serventia', params: { propConfigLivro: true }})
            }
          })

        } finally {
          loader({ active: false })
        }
      },
      previousActive () {
        window.scrollTo({top: 0, behavior: 'smooth'})
        this.wizard.ativo--
      },

      displayListErrors (title, listErrors) {
        const text = `<ul>${listErrors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        objSwal.error.title = title
        objSwal.error.html = text.replace(/\,/g,'')

        return Swal.fire(objSwal.error).then(delete objSwal.error.html)
      },

      validateCpfDuplicate () {
        const conjuges = this.habilitacao.pessoas

        let valid = true

        const erros = []

        const todosGenitores = []

        // Populando array todosGenitores
        conjuges.forEach((conjuge) => {
          if (conjuge.genitores) {
            conjuge.genitores.forEach((genitor) => {
              todosGenitores.push(genitor)
            })
          }
        })

        // Verificamos se um conjuge tem o mesmo cpf de algum genitor
        conjuges.forEach((conjuge) => {
          const genitoresComMesmoCpf = todosGenitores.filter((genitor) => {
            if (genitor.pessoa.cpf && conjuge.cpf) {
              return genitor.pessoa.cpf === conjuge.cpf
            }
          })

          if (genitoresComMesmoCpf.length) {
            valid = false

            genitoresComMesmoCpf.forEach((genitor) => {
              erros.push(`CPF do genitor ${genitor.pessoa.nome} já cadastrado para o conjuge ${conjuge.nome}`)
            })
          }
        })

        // Obtemos todos cpfs dos genitores
        const cpfsGenitores = todosGenitores.map((genitor) => genitor.pessoa.cpf)

        let duplicado = false

        // Filtramos os cpfs para encontrar possível duplicidade
        if (cpfsGenitores.length) {
          cpfsGenitores.forEach((cpfGenitor) => {
            if (cpfGenitor) {
              const doisIguais = cpfsGenitores.filter((cpf) => cpfGenitor === cpf)

              if (doisIguais.length > 1) {
                duplicado = true
              }
            }
          })
        }

        // Se houver duplicidade disparamos erro
        if (duplicado) {
          valid = false

          erros.push(`CPF dos genitores cadastrado mais de uma vez`)
        }

        if (!valid) {
          this.displayListErrors('Erro ao continuar', erros)
        }

        return valid
      },

      async nextWizard () {

        const valid = await this.$validator.validate()

        if (this.$route.params.id === 'novo') {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        if (!valid) return

        if (!this.validateCpfDuplicate()) return

        window.scrollTo({top: 0, behavior: 'smooth'})
        this.wizard.ativo++
      },
      onChangeDadosCasamento (habilitacao) {
        Object.assign(this.habilitacao, habilitacao)
        this.drafts().check(true)
      },
      onChangeConjugue (conjugue) {
        this.habilitacao.pessoas[conjugue.ordem] = conjugue.pessoa
        this.drafts().check(true)
      },
      onChangeDeclaracao (declaracao) {
        this.habilitacao.declaracao_pobreza = declaracao
      },
      async searchRascunho () {
        if (this.$route.params.id == "novo" && this.wizard.ativo == 0 && this.habilitacao.pessoas[0].nome_antigo && !this.rascunhoCriado) {
          this.rascunhoFound = await BuscaService.searchRascunhoBeforeSave(this.habilitacao.registro, this.habilitacao.pessoas[0])
          if (this.rascunhoFound) {
            this.showModalRascunho = true
          } else {
            this.drafts().check()
          }
        }
      },

      drafts () {
        const exists = async () => {
          const { id } = this.$route.params
          if (id != "novo") {
            if (Object.keys(this.propHabilitacao).length > 0) {
              Object.assign(this.habilitacao, this.propHabilitacao)
              loader({ active: false })
            } else {
              this.drafts().getDraft()
            }
          }
        }

        const getDraft = async () => {

          try {
            loader({ text: "Carregando rascunho...", active: true })
            const { document, created_at } = await RegistrosService.getRascunhoById(this.$route.params.id)
            if (typeof document == "object") {
              this.habilitacao = document

              this.rascunhoCriado = true
            } else {
              this.$router.push('/pagina-nao-encontrada')
            }

            this.getCartorio()

          } finally {
            loader({ active: false})
          }
        }

        const check = (automatic = false) => {
          if (this.$route.params.id == "novo" && this.wizard.ativo == 0 && automatic === false && this.habilitacao.pessoas[0].nome_antigo && !this.rascunhoCriado) {
            this.rascunhoCriado = true

            loader({ text: "Criando rascunho...", active: true })
            this.drafts().create()

            // mudando de passo após gerar rascunho
            // this.wizard.ativo++
            //window.scrollTo({top: 0, behavior: 'smooth'})

            this.$toast.success('Rascunho salvo com sucesso!', {
              position: 'top-right',
              duration: 5000
            })

            const nomeNovo = document.querySelector('.nome_novo')

            if (nomeNovo) nomeNovo.focus()

            /*objSwal.success.title = 'Rascunho salvo com sucesso!'
            objSwal.success.text = ''
            Swal.fire(objSwal.success).then(() => {
              setTimeout(() => {
                const nomeNovo = document.querySelector('.nome_novo')

                if (nomeNovo) nomeNovo.focus()
              }, 200)
            })*/

            return true
          } else if (this.$route.params.id != "novo") {
            this.drafts().update()
          }
        }

        const create = async () => {
          try {
            const rascunho = await RegistrosService.storeRascunho({ document: this.habilitacao })

            this.$router.push({
              name: 'habilitar_casamento',
              params: {
                id: rascunho.rascunho_id,
                propHabilitacao: rascunho
              }
            })
          } catch (error) {
            const message = getErrors(error)

            displayMessage('error', 'Erro!', message.message)
          } finally {
            loader({ active: false })
          }
        }

        const update = async () => {
          try {
            const { id } = this.$route.params
            const rascunho = await RegistrosService.updateRascunho(id, { document: this.habilitacao })
          } catch (e) {
            throw "Erro ao atualizar rascunho"
          }
        }

        return { check, exists, getDraft, create, update }
      },

      activeChange (value, passo) {
        this.hiddens.btn = false
        if (!passo) {
          const { ativo } = this.wizard
          passo = ativo
        }

        this.wizard.passos[passo].active = value
        this.hiddens.btn = true
      },

      novoDocumento (documents) {
        this.habilitacao.documentos = documents
        this.drafts().check(true)
      },

      editarDocumento (documento) {
        let doc = this.habilitacao.documentos.find((doc, index) => doc.url_s3 == documento.url_s3)
        doc.tag = documento.tag
        doc.tipo_documento = documento.tipo_documento
        doc.correspondente = documento.correspondente
        this.drafts().check(true)
      },

      async excluirDocumento (documento) {
        const docs = this.habilitacao.documentos.filter((doc, index) => doc.url_s3 != documento.url_s3)
        this.habilitacao.documentos = [ ...docs ]
        this.drafts().check(true)

        // apagamos o pdf
        if (!documento.habilitacao_casamento_documento_id) {
          await UploadTemporarioService.deleteTemporario(documento.url_s3)
        }
      },

      changeHabilitacao (registro) {
        Object.assign(this.habilitacao.registro, registro)
        this.drafts().check(true)
      },

      async getCartorio () {
        const cartorio = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
        this.habilitacao.cartorio = cartorio.data
        this.dadosCartorio = cartorio.data

        this.drafts().check(true)
      },
    }
  }
</script>

<style lang="scss">
  .HabilitacaoCasamento {
    &--uppercase {
      text-transform: uppercase ;
    }
  }
  .headerBlueCadastro{
    height: 98px;
  }
   .headerInfos{
    position: relative;
    right: 50px;
    font-size: 20px;;
   }
   .headerType{
     position: relative;
     top: 20px;
     font-size: 22px;
   }
   .cadastroInfos{
     max-width: 13rem;
   }
</style>
